<nz-spin [nzSpinning]="isLoading" [nzSize]="'large'" [nzTip]="'Loading...'" style="min-height: 200px; padding: 10px;">
  <h2>Manual Order Entry</h2>
  <form [formGroup]="manualOrderForm" (ngSubmit)="createManualOrder()" (ngReset)="resetForm()" (keydown.enter)="$event.preventDefault()">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="firstName">First Name</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="firstName" type="text" id="name" placeholder="First Name" required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="lastName">Last Name</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="lastName" type="text" id="name" placeholder="Last Name" required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="email">E-mail</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="email" type="email" id="email" placeholder="Email" required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="phoneNumber">Phone</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="phone" type="tel" id="phone" placeholder="Phone Number" maxlength="10" pattern="^(1\d{10}|\d{10})$" required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="address">Address</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="address" type="text" id="address" placeholder="Address" #addressInput required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label [nzSpan]="6" nzFor="city">City</nz-form-label>
        <nz-form-control [nzSpan]="14">
          <input nz-input formControlName="city" type="text" id="city" placeholder="City" readonly />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="6" nzFor="zip">Zipcode</nz-form-label>
        <nz-form-control [nzSpan]="14">
          <input nz-input formControlName="zip" type="text" id="zip" placeholder="Zipcode" readonly />
        </nz-form-control>
      </nz-form-item>
      
      <nz-form-item>
        <nz-form-label [nzSpan]="6" nzFor="state">State</nz-form-label>
        <nz-form-control [nzSpan]="14">
          <input nz-input formControlName="state" type="text" id="state" placeholder="State" readonly />
        </nz-form-control>
      </nz-form-item>
      

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="phone">Order Number</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="orderNumber" type="tel" id="orderNumber" placeholder="Order Number" required />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>

      <nz-form-control [nzSpan]="14" [nzOffset]="6">
        <button nz-button nzType="default" type="reset">Reset</button>
        <button nz-button nzType="primary" type="submit" [disabled]="!manualOrderForm.valid">Submit</button>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>
